import axios from '@/utils/request'

export default {
  // 2020-08-18
  findByProductId(productId) {
    return axios.get('/product-size-templates/find-product-id/' + productId)
  },
  // 2020-08-18
  insertBatch(params) {
    return axios.post('/product-size-templates/insert-batch', params)
  },
  // 2020-08-18
  delete(id) {
    return axios.delete('/product-size-templates/' + id)
  }

}

